//ReadDictaBook.js
import React, { useCallback, useState, useEffect, useHistory } from "react";
import { useSelector } from "react-redux";
import useFetch from "../../hooks/useFetch";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { useSwipeable } from "react-swipeable";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faVolumeUp,
  faSpinner,
  faCertificate,
  faBrain,
  faEye,
  faMicrophone,
  faKeyboard,
} from "@fortawesome/free-solid-svg-icons";
import Speech from "speak-tts";
import "./ReadDictaBook.css";
import SpeechInputComponent from '../../components/SpeechInputComponent';


const ReadDictaBook = () => {
  const authState = useSelector((state) => state.authReducer);
  const [fetchData, { loading }] = useFetch();
  const navigate = useNavigate();
  const location = useLocation();
  const [userId, setUserId] = useState(authState.user._id);
  const [userCode, setUserCode] = useState(authState.user.think5whyscode);
  const [userName, setUserName] = useState(authState.user.name);

  // Function to get state from localStorage
  const getStateFromLocalStorage = (key) => {
    try {
      const storedState = localStorage.getItem(key);
      return storedState ? JSON.parse(storedState) : null;
    } catch (error) {
      console.error(`Error parsing state from localStorage`, error);
      return null;
    }
  };

  const state = location.state ?? getStateFromLocalStorage("savedState") ?? {};
  const bookMasterId = state?.bookMasterId ?? "defaultBookMasterId";
  const bookCollectionName = state?.bookCollectionName ?? "defaultCollectionName";
  const pageNumber = state?.lastPageRead ?? 1; 
  const bookPages = state?.bookPages ?? [];
  const isChildren = state?.isChildren ?? 0;
  const [pageContent, setPageContent] = useState("");
  const [pageTitle, setPageTitle] = useState("");
  const [splText, setSplText] = useState("");
  const [hasAddlSplText, setHasAddlSplText] = useState(false);
  const [addlSplText, setAddlSplText] = useState([]);
  const [addlSplTextClicked, setAddlSplTextClicked] = useState(false);
  const [selectedLangCode, setSelectedLangCode] = useState('en-US');
  const [selectedAddlText, setSelectedAddlText] = useState('');
  const [bookTitle, setBookTitle] = useState("");
  const [currentPageNumber, setCurrentPageNumber] = useState(pageNumber);
  const [hasSpeech, setHasSpeech] = useState(0);
  const [hasMusic, setHasMusic] = useState(0);
  const [hasVideo, setHasVideo] = useState(0);
  const [videoUrl, setVideoUrl] = useState(0);
  const [pageCount, setPageCount] = useState(bookPages);
  const [isSpeaking, setIsSpeaking] = useState(false);
  const [isListening, setIsListening] = useState(false);
  const [pageLoadTime, setPageLoadTime] = useState(null);
  const [readTimeInMiliseconds, setReadTimeInMiliseconds] = useState(0);
  const [readingRemarks, setReadingRemarks] = useState("");
  const [isLogSaved, setIsLogSaved] = useState(true);
  const [isInteracted, setIsInteracted] = useState(false);
  const [successMessage, setSuccessMessage] = useState(false);
  const [showText, setShowText] = useState(false);
  const [elapsedTime, setElapsedTime] = useState(0);
  const [error, setError] = useState(false);
  const [errors, setErrors] = useState();
  const [isMicrophoneClicked, setIsMicrophoneClicked] = useState(false);
  const [isCertificateClicked, setIsCertificateClicked] = useState(false);
  const [message, setMessage] = useState(null); 
  const [isError, setIsError] = useState(false);
  const [teacherPageTitle, setTeacherPageTitle] = useState('');
  const [teacherPageContent, setTeacherPageContent] = useState('');
  const [teacherCode, setTeacherCode] = useState('');
  const [teacherName, setTeacherName] = useState('');
  const [myCustomUserDictaPages, setMyCustomUserDictaPages]=useState([]);
  const [numberOfCustomUserPages, setNumberOfCustomUserPages]=useState(0);
  const [showTest, setShowTest] = useState(false);
  const [showMemoryMap, setShowMemoryMap] = useState(false);
  const [showTalkingInput, setShowTalkingInput] = useState(false);
  const [inputSpeak, setInputSpeak] = useState(false);
  const [teacherContentCode,setTeacherContentCode]=useState('');
  const [teacherContentCodeFound,setTeacherContentCodeFound]=useState(false);
  const [teacherDictaData,setTeacherDictaData]=useState();
  const [verifyTeacherContentCodeClicked,setVerifyTeacherContentCodeClicked]=useState(false);
  const [saveCustomRecordClicked,setSaveCustomRecordClicked]=useState(false);
  const [userDictaRecordSaved,setUserDictaRecordSaved]=useState(false);
  const [showCustom,setShowCustom]=useState(false);

  useEffect(() => {
    const startTime = new Date();
    setPageLoadTime(startTime);
  }, []); 

  const saveStateToLocalStorage = (key, state) => {
    try {
      const jsonState = JSON.stringify(state);
      localStorage.setItem(key, jsonState);
    } catch (error) {
      console.error(`Error saving state to localStorage`, error);
    }
  };

  useEffect(() => {
    const savedState = getStateFromLocalStorage("savedState");
    if (!location.state && savedState) {
      navigate(location.pathname, { state: savedState, replace: true });
    } else if (
      location.state &&
      JSON.stringify(location.state) !== JSON.stringify(savedState)
    ) {
      saveStateToLocalStorage("savedState", location.state);
    }
  }, [location.state, navigate, location.pathname]);

  useEffect(() => {
    setPageLoadTime(new Date());
  }, []);

  const resetElapsedTime = () => {
    setElapsedTime(0);
  };
  useEffect(() => {
    const timer = setInterval(() => {
      setElapsedTime((prevTime) => prevTime + 1);
    }, 1000);
    return () => clearInterval(timer);
  }, []);

  const fetchMyCustomDictaPages = useCallback(() => {
    const config = {
        url: "/userdictapages/my",
        method: "post",
        headers: { Authorization: authState.token },
        data: {userId: userId}
    };
    // console.log("Request for User Custom Pages On Load: ",config)

    fetchData(config, { showSuccessToast: false })
        .then(response => {
            if (response && Array.isArray(response.mycustomdictapages)) {
                setMyCustomUserDictaPages(response.mycustomdictapages);
                setNumberOfCustomUserPages(myCustomUserDictaPages.length);
            } else {
                console.error("Invalid response format: Custome dicta pages not found in response");
            }
        })
        .catch(error => {
            console.error("Error fetching Custom Dicta Pages:", error);
        });
  }, [authState.token, fetchData]);


  useEffect(() => {
      if (!authState.isLoggedIn) return;
      fetchMyCustomDictaPages();
  }, [authState.isLoggedIn, fetchMyCustomDictaPages]);
  
  // BookPage
  const fetchBookPage = useCallback(() => {
    const config = {
      url: "/readbook",
      method: "post",
      headers: { Authorization: authState.token },
      data: {
        bookMasterId,
        bookCollectionName,
        currentPageNumber,
        readerCode: authState.user.think5whyscode,
        readerName: authState.user.name
      },
    };

    fetchData(config, { showSuccessToast: false })
      .then((response) => {
        if (response && response.pageContent) {
          // console.log("Page Content ",response);
          setPageTitle(response.pageTitle);
          setPageContent(response.pageContent);
          setSplText(response.splText);
          setBookTitle(response.bookTitle);
          setHasSpeech(response.hasSpeech);
          setHasAddlSplText(response.hasAddlSplText);
          setAddlSplText(response.addlSplText);
          setError(null);
        } else {
          console.error(
            "Invalid response format: Set master list not found in response"
          );
        }
        resetElapsedTime();
        setPageLoadTime(new Date());
      })
      .catch((error) => {
        console.error("Error fetching book page:", error);
        console.error("Error fetching set masters:", error);
      });
  }, [
    authState.token,
    bookMasterId,
    bookTitle,
    bookCollectionName,
    currentPageNumber,
    fetchData,
  ]);

  useEffect(() => {
    if (!authState.isLoggedIn) return;
    fetchBookPage();
  }, [
    authState.isLoggedIn,
    fetchBookPage,
    location.state.bookMasterId,
    location.state.bookCollectionName,
    location.state.lastPageRead,
  ]);

  // Save Read Log
  const saveReadLog = async (remarks, elapsedTime, whichButton) => {
    try {
      const readingRemarks = isChildren === 1 ? splText : remarks;
      const response = await fetch("/api/myreadinglog", {
        method: "POST",
        headers: {
          Authorization: authState.token,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          bookId: bookMasterId,
          userId: userId,
          dateRead: new Date(),
          pageNumber: currentPageNumber,
          readTimeInMiliseconds: elapsedTime,
          readingRemarks: readingRemarks,
          readingMode: "Dicta",
          isActive: 1,
          isDeleted: 0,
          coReaderId: userId,
          readerCode: authState.user.think5whyscode,
          readerName: authState.user.name,
        }),
      });

      if (!response.ok) {
        throw new Error("Failed to update app like");
      }

      const data = await response.json();
      setSuccessMessage(true);
      setReadTimeInMiliseconds(0);
      setPageLoadTime(new Date());
    } catch (error) {
      console.error("Error while saving read log:", error);
    }
  };

  const saveReadLogIfNeeded = () => {
    if (isInteracted && !isLogSaved) {
      setCurrentPageNumber(currentPageNumber);
      let currentTime = new Date();
      const elapsedTime = currentTime - pageLoadTime;
      setReadTimeInMiliseconds(elapsedTime);
      setReadingRemarks("Swipe");
      saveReadLog(currentPageNumber, elapsedTime, "Selected Page");
      currentTime = new Date();
      setPageLoadTime(currentTime);
      setIsLogSaved(true);
    }
  };

  useEffect(() => {
    setReadTimeInMiliseconds();
    setReadingRemarks();
    setPageLoadTime(new Date());
  }, []);

  useEffect(() => {
    //
  }, [readTimeInMiliseconds]);

  const handlePageChange = (e) => {
    const selectedPage = parseInt(e.target.value);
    setCurrentPageNumber(selectedPage);
    const currentPageNumber = selectedPage;
    setReadingRemarks("Select Page Clicked");
    let currentTime = new Date();
    const elapsedTime = currentTime - pageLoadTime;
    setReadTimeInMiliseconds(elapsedTime);

    saveReadLog(currentPageNumber, elapsedTime, "Selected Page");
    currentTime = new Date();
    setPageLoadTime(currentTime);
    // setSelectedLangCode('hi-IN');
    setSelectedAddlText('');
    setShowCustom(false);
  };

  useEffect(() => {
    setReadTimeInMiliseconds();
    setReadingRemarks();
    setPageLoadTime(new Date());
  }, []);

  useEffect(() => {
    //
  }, [readTimeInMiliseconds]);

  const handleNextPage = () => {
    setReadingRemarks("Next button clicked");
    let currentTime = new Date();
    const elapsedTime = currentTime - pageLoadTime;
    setReadTimeInMiliseconds(elapsedTime);

    saveReadLog(currentPageNumber, elapsedTime, "Next Button");
    currentTime = new Date();
    setPageLoadTime(currentTime);

    if (currentPageNumber < pageCount) {
      speech.cancel();
      setIsSpeaking(false);
      setCurrentPageNumber(currentPageNumber + 1);
    }
    setSelectedAddlText('');
    setShowCustom(false);
  };

  useEffect(() => {
    setReadTimeInMiliseconds();
    setReadingRemarks();
    setPageLoadTime(new Date());
  }, []);

  useEffect(() => {
    //
  }, [readTimeInMiliseconds]);

  const handlePrevPage = () => {
    setReadingRemarks("Prev button clicked");
    let currentTime = new Date();
    const elapsedTime = currentTime - pageLoadTime;
    setReadTimeInMiliseconds(elapsedTime);
    saveReadLog(currentPageNumber, elapsedTime, "Prev Button");
    currentTime = new Date();
    setPageLoadTime(currentTime);
    if (currentPageNumber > 1) {
      speech.cancel();
      setIsSpeaking(false);
      setCurrentPageNumber(currentPageNumber - 1);
    }
    setSelectedAddlText('');
    setShowCustom(false);
  };

  useEffect(() => {
    setReadTimeInMiliseconds();
    setReadingRemarks();
    setPageLoadTime(new Date());
  }, []);

  useEffect(() => {
    //
  }, [readTimeInMiliseconds]);

  const handleClose = () => {
    setReadingRemarks("Close button clicked");
    const currentTime = new Date();
    const elapsedTime = currentTime - pageLoadTime;
    setReadTimeInMiliseconds(elapsedTime);
    const remarks = "Closed";
    saveReadLog(currentPageNumber, elapsedTime, "Close Button")
      .then(() => {
        window.location.href = "/dictabook-home";
      })
      .catch((error) => {
        console.error("Error saving log:", error);
      });
  };

  useEffect(() => {
    setReadTimeInMiliseconds(0);
    setPageLoadTime(new Date());
  }, []);

  useEffect(() => {
    //
  }, [readTimeInMiliseconds]);

  const speech = new Speech();

  const toggleSpeech = (myText, lang, pause, rate, pitch, vol, speaking) => {
    setSelectedLangCode(lang);
    setSelectedAddlText(myText);
  
    if (!speaking) {
      speech.cancel();
      setIsSpeaking(false);
      return;
    }
    speech.setRate(rate);
    speech.setPitch(pitch);
    speech.setVolume(vol);
    speech.setLanguage(lang);
  
    const textList = myText.replace(/[\[\]]/g, '').split('][');
  
    const speakTextWithPause = (index) => {
      if (index < textList.length) {
        const currentText = textList[index];
        const utterance = new SpeechSynthesisUtterance(currentText);
        utterance.rate = rate;
        utterance.pitch = pitch;
        utterance.volume = vol;
        utterance.lang = lang;
  
        utterance.onend = () => {
          setTimeout(() => {
            speakTextWithPause(index + 1);
          }, pause * 1000); 
        };
  
        speech.speak(utterance);
      } else {
        setIsSpeaking(false); 
      }
    };
    speakTextWithPause(0);
  };
  
  useEffect(() => {
    return () => {
      if (isSpeaking) {
        speech.cancel();
        setIsSpeaking(false);
      }
    };
  }, [isSpeaking]);


  const toggleTest = () => {
    setShowTest(!showTest);  
  };

  const toggleMemoryMap = () => {
    setShowMemoryMap(!showMemoryMap);  
  };

  
  const toggleTalkingInput = () => {
    setShowTalkingInput(!showTalkingInput);  
  };
  
  
  const toggleSpeak = () => {
    setInputSpeak(!inputSpeak);  
  };
  
  const handleToggleShowText = () => {
    setShowText(!showText);  
  };

  const handleCertificateClick = () => {
    setIsCertificateClicked(true);
    toggleTest(splText, selectedLangCode);
  };

  const handleOtherButtonClick = () => {
    setIsCertificateClicked(false);
  };

  const handleCreateDictation = async () => {
      const pageContent = '[][][][][][][][][][]'; 
      const teacherCode = '';
      const teacherContentCode = '';
      const isFinal = false;
      const dateCreated = new Date();
  
      const payload = {
        userId,
        bookMasterId,
        pageNumber,
        pageContent,
        teacherCode,
        teacherContentCode,
        isFinal,
        dateCreated,
        createdBy: userId,
      };
  
      try {
        const response = await fetch('/api/userdictapages', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(payload),
        });
  
        const data = await response.json();
        if (response.ok) {
          alert('Dictation created successfully!');
        } else {
          alert(`Error: ${data.message}`);
        }
      } catch (error) {
        console.error('Error:', error);
        alert('Failed to create dictation.');
      }
    };

  const handleVerifyTeacherContentCode = () => {
    // console.log(teacherContentCode);
    setTeacherContentCode(teacherContentCode);
    setError('');
    if (teacherContentCode.length !== 20) {
      setError('Teacher Content Code must be exactly 20 characters long.');
      return;
    }
    if (teacherContentCode.slice(0, 2) !== 'TU') {
      setError('Teacher Content Code must start with "TU".');
      return;
    }
    if (teacherContentCode[14] !== '_' && teacherContentCode[14] !== '-') {
      setError('The 15th character must be "_" or "-".');
      return;
    }
    setVerifyTeacherContentCodeClicked(true);
    fetchTeacherContent(teacherContentCode);
  };

  const fetchTeacherContent = useCallback((teacherContentCode) => {
    const config = {
      url: "/teacherdictapages/getteachercontent",
      method: "post",
      headers: { Authorization: authState.token },
      data: {
        userCode: userCode,
        teacherContentCode: teacherContentCode
      },
    };
    // console.log("Teacher Page req payload: ",config);

    fetchData(config, { showSuccessToast: false })
      .then((response) => {
        if (response && response.teacherdictadata) {
          // console.log("Teacher Page Content Response: ",response.teacherdictadata);
          setTeacherContentCodeFound(true)
          setTeacherDictaData(response.teacherdictadata);
          setTeacherPageTitle(response.teacherdictadata.pageTitle);
          setTeacherPageContent(response.teacherdictadata.pageContent);
          setTeacherCode(response.teacherdictadata.teacherCode);
          setTeacherName(response.teacherdictadata.teacherName);
          setTeacherContentCode(response.teacherdictadata.teacherContentCode);
        } else {
          console.error("Invalid response format: Teacher dicta content not found in the response.");
          }
      })
      .catch((error) => {
        console.error("Error fetching Teacher Dicta Data:", error);
      });
  }, [ authState.token, teacherContentCode, fetchData]);

  useEffect(() => {
    if (teacherDictaData) {
      // console.log('Use Effect Teacher Dicta Data:', teacherDictaData);
      // console.log('Teacher Page Title:', teacherPageTitle);
      // console.log('Teacher Page Content:', teacherPageContent);
      // console.log('Teacher Code:', teacherCode);
      // console.log('Teacher Name:', teacherName);
    }
  }, [teacherDictaData, teacherPageTitle, teacherPageContent, teacherCode, teacherName]);

  const handleSaveCustomRecord = () => {
    setSaveCustomRecordClicked(true);
    saveCustomContent();
  };

  const saveCustomContent = useCallback(() => {
    // console.log("State before saving:", {
    //   bookTitle,
    //   teacherPageTitle,
    //   teacherPageContent,
    //   teacherCode,
    //   teacherName,
    //   teacherContentCode
    // });
    const config = {
      url: "/userdictapages/save",
      method: "post",
      headers: { Authorization: authState.token },
      data: {
        userId: userId,
        userCode: userCode,
        userName: userName,
        pageNumber: currentPageNumber,
        bookId: bookMasterId,
        bookTitle: bookTitle,
        pageTitle: teacherPageTitle,
        pageContent: teacherPageContent,
        teacherCode: teacherCode,
        teacherName: teacherName,
        teacherContentCode: teacherContentCode,
        dateCreated: new Date(),
        createdBy: userId
      },
    };
    // console.log("Saving user dicta page from teacher data req payload: ",config);

    fetchData(config, { showSuccessToast: false })
      .then((response) => {
        if (response && response.status) {
          // console.log("user dicta page response ",response);
          setUserDictaRecordSaved(true);
        } else {
          console.error("User Custom Dicta Data Record not Saved!! Retry.");
          }
      })
      .catch((error) => {
        console.error("Error Saving User Custom Dicta Data", error);
      });
  }, [
    bookTitle, 
    teacherPageTitle, 
    teacherPageContent, 
    teacherCode, 
    teacherName, 
    teacherContentCode, 
    userId, 
    userCode, 
    userName, 
    currentPageNumber, 
    bookMasterId, 
    authState.token, 
    fetchData
  ]);

  const handleOK = () => {
    window.location.href = "/dictabook-home";
  };

  const extractTeacherContent = (content) => {
    const contentArray = content.match(/\[(.*?)\]/g)?.map(word => word.slice(1, -1)) || [];
    const formattedContent = contentArray.map((word, index) => `${index + 1}. ${word} ♦`);
    return formattedContent;
  };

  const extractPageContent = () => {
    const contentArray = pageContent.match(/\[(.*?)\]/g)?.map(word => word.slice(1, -1)) || [];
    return contentArray;
  };

  const pageContentList = extractPageContent();

  const [inputContentList, setInputContentList] = useState(
    Array.from({ length: 10 }, (_, index) => ({
      id: `userInputText${index + 1}`,
      value: ''
    }))
  );

  const handleInputChange = (id, value) => {
    setInputContentList(prevList =>
      prevList.map(item =>
        item.id === id ? { ...item, value } : item
      )
    );
  };

// Validate input on blur
const handleBlur = (id, index) => {
  setInputContentList(prevList =>
    prevList.map(item => {
      if (item.id === id) {
        const isValid = item.value.toLowerCase() === pageContentList[index].toLowerCase();
        return { ...item, backgroundColor: isValid ? 'lightgreen' : 'lightcoral' };
      }
      return item;
    })
  );
};

const handleMicButtonClick = () => {
  setIsMicrophoneClicked(prevState => !prevState);
};

const handleSwipe = () => {
  setIsInteracted(true);
  setReadingRemarks("Swiped");
  saveReadLogIfNeeded();
  setShowCustom(false);
};

const swipeHandlers = useSwipeable({
  onSwipedLeft: () => {
    handleSwipe();
    handleNextPage();
    setShowCustom(false);
  },
  onSwipedRight: () => {
    handleSwipe();
    handlePrevPage();
    setShowCustom(false);
  },
});

const handleStartCustom = () => {
  setShowCustom(true);
};

  return (
    <div className="my-1 mx-auto py-2 bg-white text-black fixed-height-container" style={{ height: "100vh", overflow: "auto" }}>
      {loading ? (
        <div className="spinner-container">
          <div className="spinner">
            <FontAwesomeIcon icon={faSpinner} spin />
          </div>
        </div>
      ) : (
        <>
          <div
            className="fixed-height-container mt-2 mb-2"
            style={{
              flex: 1,
              overflowY: "auto",
              maxWidth: "100%",
              maxHeight: "100vh",
            }}
          >
            <div className="flex justify-between items-center mb-4 bg-cyan-900 text-white mr-1 ml-1">
              <div>
                <div className="text-wrap flex justify-center">
                  <h1 className="mt-1 mx-2 bg-cyan-900 text-white">
                    <i className="fa fa-star text-white text-xl" aria-hidden="true"></i>
                    <i className="fa fa-book-open text-white text-xl" aria-hidden="true"></i>
                    <span className="text-yellow-300 ml-2 text-wrap text-xl">{bookTitle}</span>
                  </h1>
                </div>
                <h3 className="book-timer ml-2 text-xl">{elapsedTime} seconds [{pageTitle}]{' '}{showCustom ? "Custom":"Standard"}</h3>
              </div>
              <div>
                <button className="mx-2 bg-cyan-900" onClick={handleClose}>
                  <i className="fa fa-times text-3xl" aria-hidden="true"></i>
                </button>
              </div>
            </div>
  
            <div className="ml-1 mr-1 h-15 flex justify-between bg-black">
              <button
                className="ml-1 mt-2 max-w-10 bg-orange-600 text-white"
                onClick={() => {
                  toggleSpeech(pageContent, selectedLangCode, 5, 1.0, 1.0, 1.0, !isSpeaking);
                }}
                disabled={isCertificateClicked}
              >
                <FontAwesomeIcon icon={faVolumeUp} />
              </button>
              <button
                className="ml-1 mt-2 max-w-10 bg-orange-600 text-white"
                onClick={handleToggleShowText}
                disabled={isCertificateClicked}
              >
                <FontAwesomeIcon icon={faEye} />
              </button>
              <button
                className="ml-1 mt-2 max-w-10 bg-orange-600 text-white"
                onClick={toggleMemoryMap}
              >
                <FontAwesomeIcon icon={faBrain} />
              </button>
              <button
                className="ml-1 mt-2 max-w-10 bg-purple-800 text-white"
                onClick={handleCertificateClick}
              >
                <FontAwesomeIcon icon={faCertificate} />
              </button>
              <button
                title="Prev"
                className="ml-1 mt-2 max-w-10 bg-cyan-800 text-white"
                onClick={handlePrevPage}
                disabled={isCertificateClicked || currentPageNumber === 1}
              >
                <i className="fa fa-angle-left text-2xl" aria-hidden="true"></i>
              </button>
              <select
                className="ml-1 mt-3 max-w-15 text-lg bg-cyan-800 text-white border-2 border-cyan-900"
                value={currentPageNumber}
                onChange={handlePageChange}
                disabled={isCertificateClicked}
              >
                {[...Array(pageCount).keys()].map((page) => (
                  <option
                    className="text-white text-2xl"
                    key={page + 1}
                    value={page + 1}
                  >
                    {page + 1}
                  </option>
                ))}
              </select>
              <button
                title="Next"
                className="ml-1 mt-2 max-w-10 bg-cyan-800 text-white"
                onClick={handleNextPage}
                disabled={isCertificateClicked || currentPageNumber === pageCount}
              >
                <i className="fa fa-angle-right text-2xl" aria-hidden="true"></i>
              </button>
            </div>
  
            {currentPageNumber === 1 ? (
              <div
                className="page-content mx-4 my-6 p-6 rounded-lg bg-white shadow-lg"
                style={{ minHeight: "100%" }}
                dangerouslySetInnerHTML={{ __html: pageContent }}
                {...swipeHandlers}
              />
            ) : (
              <>
                {pageTitle !== "Custom" ? (
                  <>
                    {!showMemoryMap && !isCertificateClicked ? (
                      <div className="mt-4 ml-2 mr-2 flex flex-col items-center justify-center" {...swipeHandlers}>
                        <ul
                          className="page-content-list flex flex-col items-center"
                          style={{
                            color: showText ? "#333" : "#f5f5f5",
                            backgroundColor: "#fff",
                            padding: "4px",
                            borderRadius: "12px",
                            boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
                            fontFamily: "'Inter', sans-serif",
                            fontSize: "18px",
                            maxWidth: "600px",
                            width: "100%",
                          }}
                        >
                          {pageContentList.map((item, index) => (
                            <li key={index} className="my-0 w-full flex justify-center">
                              <button
                                className={`py-3 px-6 rounded-full duration-300 ${showText ? "bg-blue-500 text-white" : "bg-gray-300 text-gray-300"}`}
                                style={{
                                  minWidth: "100%",
                                  textAlign: "center",
                                  cursor: showText ? "pointer" : "default",
                                }}
                              >
                                {item}
                              </button>
                            </li>
                          ))}
                        </ul>
                      </div>
                    ) : (
                      <div className="mt-4 ml-2 mr-2 flex flex-col items-center">
                        {inputContentList.map((item, index) => (
                          <div key={item.id} className="flex items-center mb-4 w-full">
                            <div className="flex-shrink-0" style={{ width: '10%' }}>
                              <button
                                type="button"
                                className="p-3 bg-blue-600 text-white rounded-full hover:bg-blue-700 focus:outline-none w-full h-full"
                                onClick={handleMicButtonClick}
                              >
                                <FontAwesomeIcon icon={isMicrophoneClicked ? faKeyboard : faMicrophone} />
                              </button>
                            </div>
  
                            <div className="flex-grow" style={{ width: 'calc(90% - 2rem)' }}>
                              {isMicrophoneClicked ? (
                                <SpeechInputComponent
                                  label={index + 1}
                                  name="myword"
                                  value={item.value}
                                  onChange={(e) => handleInputChange(item.id, e.target.value)}
                                  onBlur={() => handleBlur(item.id, index)}
                                  className="p-2 border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 w-full"
                                  placeholder="Click Mic and Speak..."
                                  maxLength="250"
                                />
                              ) : (
                                <input
                                  id={item.id}
                                  type="text"
                                  value={item.value}
                                  onChange={(e) => handleInputChange(item.id, e.target.value)}
                                  onBlur={() => handleBlur(item.id, index)}
                                  placeholder={`Enter text for ${item.id}`}
                                  className="p-2 border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 w-full"
                                  style={{ backgroundColor: item.backgroundColor, width: '100%' }}
                                />
                              )}
                            </div>
                          </div>
                        ))}
                      </div>
                    )}
                  </>
                ) : (
                  <div className="flex flex-col justify-center">
                    <div className="flex flex-col items-center mt-8 mb-8">
                      {myCustomUserDictaPages.some((mydicta) => mydicta.pageNumber === currentPageNumber) ? (
                        <div className="text-center">
                          <p className="text-green-600 text-xl">You Have Your Custom Dicta Set For This</p>
                          <button className="mt-4 bg-blue-600 text-white p-2 rounded-md"
                            onClick={handleStartCustom}
                          >
                            Start
                          </button>
                        </div>
                      ) : (
                        <>
                          <div className="text-center">
                            <p className="text-black ml-2 text-wrap text-xl">This Space is Yours</p>
                            {myCustomUserDictaPages.map((mydicta, index) => (
                              <React.Fragment key={index}>
                                <p>{mydicta.pageNumber}</p>
                              </React.Fragment>
                            ))}
                          </div>
                          <div className="flex flex-col justify-center items-center">
                            <p>Teacher Content Code*:</p>
                            <input
                              id="teacherContentCode"
                              type="text"
                              value={teacherContentCode}
                              onChange={(e) => setTeacherContentCode(e.target.value)} 
                              placeholder="Input 20 Character Teacher Content Code..."
                              className="p-2 border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 w-full"
                              style={{ width: '250px' }}
                            />
                            <button
                              className="ml-1 mt-2 bg-blue-600 text-black"
                              onClick={() => c(teacherContentCode)}
                              disabled={verifyTeacherContentCodeClicked}
                            >
                              Pull Data
                            </button>
                            {error && <p className="text-red-500 mt-2">{error}</p>}
                          </div>
                          {verifyTeacherContentCodeClicked && (
                            teacherContentCodeFound ? (
                              <div className="flex flex-col justify-center items-center bg-black">
                                <p className="font-semibold">Set Title</p>
                                <p>{teacherDictaData.pageTitle}</p>
                                <p className="font-semibold">Set Content</p>
                                <p>{extractTeacherContent(teacherDictaData.pageContent)}</p>

                                <p className="font-semibold">Teacher</p>
                                <p>{teacherDictaData.teacherName}</p>

                                <p className="text-purple-700">{teacherDictaData.isFree ? "Complimentary" : "Charges: ₹ " + teacherDictaData.price.toFixed(2)}</p>
                                <button
                                  className="ml-1 mt-2 bg-blue-600 text-white"
                                  onClick={handleSaveCustomRecord}
                                  disabled={saveCustomRecordClicked}
                                >
                                  Save Custom {teacherDictaData.pageTitle} from {teacherDictaData.teacherName}
                                </button>
                                {error && !userDictaRecordSaved && <p className="text-red-500 mt-2">{error}</p>}
                                {userDictaRecordSaved && (
                                  <>
                                    <p className="text-xl text-green-800">Your Custom Page Content is Available Now!! Reload the Page and start using it.</p>
                                    <button
                                    className="ml-1 mt-2 bg-blue-600 text-white"
                                    onClick={handleOK}
                                  >
                                    OK
                                  </button>
                                  </>
                                )}
                              </div>
                            ) : (
                              <>
                                <p className="text-xl text-red-500">Content not Found / Content is restricted for You!!</p>
                              </>
                            )
                          )}
                        </>
                      )}
                    </div>
                    { pageTitle === ' Custom' && (
                      <>
                      {showCustom ? (
                        <div className="mt-4 ml-2 mr-2 flex flex-col items-center justify-center" {...swipeHandlers}>
                          <ul
                            className="page-content-list flex flex-col items-center"
                            style={{
                              color: showText ? "#333" : "#f5f5f5",
                              backgroundColor: "#fff",
                              padding: "4px",
                              borderRadius: "12px",
                              boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
                              fontFamily: "'Inter', sans-serif",
                              fontSize: "18px",
                              maxWidth: "600px",
                              width: "100%",
                            }}
                          >
                            {pageContentList.map((item, index) => (
                              <li key={index} className="my-0 w-full flex justify-center">
                                <button
                                  className={`py-3 px-6 rounded-full duration-300 ${showText ? "bg-blue-500 text-white" : "bg-gray-300 text-gray-300"}`}
                                  style={{
                                    minWidth: "100%",
                                    textAlign: "center",
                                    cursor: showText ? "pointer" : "default",
                                  }}
                                >
                                  {item}
                                </button>
                              </li>
                            ))}
                          </ul>
                        </div>
                      ) : (
                        <div className="mt-4 ml-2 mr-2 flex flex-col items-center">
                          {inputContentList.map((item, index) => (
                            <div key={item.id} className="flex items-center mb-4 w-full">
                              <div className="flex-shrink-0" style={{ width: '10%' }}>
                                <button
                                  type="button"
                                  className="p-3 bg-blue-600 text-white rounded-full hover:bg-blue-700 focus:outline-none w-full h-full"
                                  onClick={handleMicButtonClick}
                                >
                                  <FontAwesomeIcon icon={isMicrophoneClicked ? faKeyboard : faMicrophone} />
                                </button>
                              </div>

                              <div className="flex-grow" style={{ width: 'calc(90% - 2rem)' }}>
                                {isMicrophoneClicked ? (
                                  <SpeechInputComponent
                                    label={index + 1}
                                    name="myword"
                                    value={item.value}
                                    onChange={(e) => handleInputChange(item.id, e.target.value)}
                                    onBlur={() => handleBlur(item.id, index)}
                                    className="p-2 border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 w-full"
                                    placeholder="Click Mic and Speak..."
                                    maxLength="250"
                                  />
                                ) : (
                                  <input
                                    id={item.id}
                                    type="text"
                                    value={item.value}
                                    onChange={(e) => handleInputChange(item.id, e.target.value)}
                                    onBlur={() => handleBlur(item.id, index)}
                                    placeholder={`Enter text for ${item.id}`}
                                    className="p-2 border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 w-full"
                                    style={{ backgroundColor: item.backgroundColor, width: '100%' }}
                                  />
                                )}
                              </div>
                            </div>
                          ))}
                        </div>
                      )}
                      </>
                    )}
                  </div>
                )}
              </>
            )}
          </div>
        </>
      )}
    </div>
  );
  
};

export default ReadDictaBook;
